// Página pública (sem login) da Política de Privacidade (BUG-92). Sem
// MainLayout/Sidebar de propósito - mesmo padrão do TrackingView (BUG-61):
// tela isolada, só JSX estático, sem chamadas de API.
export default function PrivacyView() {
  return (
    <div className="min-h-screen bg-gray-50 pb-8">
      <div className="bg-white border-b border-gray-200 px-4 py-4">
        <h1 className="text-lg font-semibold text-gray-900">Política de Privacidade — EntregaFácil</h1>
        <p className="text-sm text-gray-500 mt-1">Última atualização: 29 de setembro de 2026</p>
      </div>

      <div className="max-w-2xl mx-auto p-4 space-y-6">
        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">1. Quem somos</h2>
          <p className="text-sm text-gray-700">
            O EntregaFácil é uma plataforma de gestão de entregas para pequenos negócios: otimização de rotas, avisos ao cliente por WhatsApp e link de rastreio. Para dúvidas ou pedidos sobre seus dados, fale com a gente pelo e-mail entrega.facil.am@gmail.com.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">2. Quem decide sobre os dados</h2>
          <p className="text-sm text-gray-700">
            Os negócios que usam o EntregaFácil (lojistas) cadastram os dados de seus clientes e entregadores e decidem para que usá-los. O EntregaFácil trata esses dados em nome do lojista, para prestar o serviço. Sobre os dados da conta do próprio lojista, o EntregaFácil é o responsável pelo tratamento.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">3. Quais dados tratamos</h2>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
            <li>Do lojista: nome, e-mail, telefone, nome da empresa, documento (opcional) e endereço da loja. A senha é guardada de forma protegida (hash), nunca em texto puro.</li>
            <li>Dos destinatários das entregas: nome, telefone, e-mail (opcional), endereço e localização no mapa.</li>
            <li>Dos entregadores: nome e telefone.</li>
            <li>Das entregas e mensagens: status da entrega, avisos enviados por WhatsApp e respostas dos destinatários (por exemplo, a nota e o comentário de uma avaliação).</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">4. Para que usamos</h2>
          <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
            <li>Organizar entregas e calcular a melhor rota.</li>
            <li>Avisar o destinatário por WhatsApp sobre a entrega, pedir confirmação de localização ou de endereço e coletar avaliação.</li>
            <li>Mostrar o rastreio da entrega ao destinatário.</li>
            <li>Manter a conta, a segurança e o funcionamento do serviço.</li>
          </ul>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">5. O que o link de rastreio mostra</h2>
          <p className="text-sm text-gray-700">
            O link público de rastreio mostra apenas o status da entrega, a posição na fila, a previsão de chegada e o primeiro nome do entregador. Ele não mostra endereço de entrega.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">6. Com quem compartilhamos</h2>
          <p className="text-sm text-gray-700">
            Usamos prestadores de serviço para operar a plataforma: de mensagens (para enviar e receber os avisos por WhatsApp), de mapas (para localizar endereços e calcular rotas) e de hospedagem e banco de dados. Alguns desses servidores ficam fora do Brasil. Não vendemos dados pessoais.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">7. Por quanto tempo guardamos</h2>
          <p className="text-sm text-gray-700">
            Guardamos os dados enquanto a conta do lojista estiver ativa ou for necessário para prestar o serviço e cumprir obrigações legais. Você pode pedir a exclusão pelo e-mail acima.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">8. Seus direitos</h2>
          <p className="text-sm text-gray-700">
            Você pode pedir: confirmação de que tratamos seus dados, acesso, correção, anonimização, bloqueio ou eliminação de dados desnecessários, portabilidade, informação sobre com quem compartilhamos e revogação de consentimento, quando ele for a base do tratamento. Se você é destinatário de uma entrega, também pode falar com o lojista que fez o cadastro. Responderemos dentro dos prazos da Lei Geral de Proteção de Dados (LGPD, Lei 13.709/2018).
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">9. Segurança</h2>
          <p className="text-sm text-gray-700">
            Usamos conexão segura (HTTPS), acesso por conta com login, links públicos com código único e prazo de validade, e separação dos dados de cada lojista. Nenhum sistema é totalmente livre de risco, e trabalhamos para reduzir esse risco.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">10. Armazenamento no navegador</h2>
          <p className="text-sm text-gray-700">
            O painel do lojista guarda no navegador as informações de sessão (login) para você não precisar entrar a cada visita. Não usamos cookies de publicidade.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">11. Mudanças nesta política</h2>
          <p className="text-sm text-gray-700">
            Podemos atualizar esta política. A data no topo mostra a última versão.
          </p>
        </section>
      </div>
    </div>
  )
}
